import { useSelector } from "react-redux"
import { Navigate, useLocation } from "react-router-dom"
import { tourSteps } from "../utils/tutorialSteps.js"

export const useFeatureLock = () => {
    const { young, buried, mature } = useSelector(state => state.wordCounts)
    const hintProgress = useSelector(state => state.hintProgress)
     
    const onboardingStep = useSelector((state) => state.onboardingStep)

    const materialsLocked = (young + mature + buried) < 50
    const wordCountUnlocksChat = (mature + buried) >= 150

    const materialsProgress = Math.min((young + mature + buried) / 50, 1)
    const chatProgress = Math.min((mature + buried) / 150, 1)

    const chatPageIndex = tourSteps.findIndex(s => s.id === "chat-page")
    const currentStepIndex = tourSteps.findIndex(s => s.id === onboardingStep)
    const hasReachedChatChapter =
        onboardingStep === "onboarding-complete" ||
        (currentStepIndex !== -1 && currentStepIndex >= chatPageIndex)

    const chatGatedByTutorial = !hasReachedChatChapter

    const hasSeenRequiredHints = !!(
        hintProgress?.flashcardFrontHintShown &&
        hintProgress?.flashcardBackHintShown &&
        hintProgress?.videoHintShown
    )

    const chatLocked = chatGatedByTutorial || !wordCountUnlocksChat || !hasSeenRequiredHints

    return {
        materialsLocked: false,
        chatLocked,

        materialsProgress: materialsProgress,
        chatProgress: chatProgress,
    }
}

export const FeatureLockGuard = ({ feature, children }) => {
    const { materialsLocked, chatLocked } = useFeatureLock()
    const location = useLocation()

    const isLocked = {
        materials: materialsLocked,
        chat: chatLocked,
    }[feature]

    if (isLocked) {
        return <Navigate to="/dashboard" replace state={{ from: location }} />
    }

    return children
}